import { Add, TrashOutlined } from 'assets/icons/revamp';
import BaseButton from 'components/ui/BaseButton';
import FloatingLabelInput from 'components/ui/FloatingLabelInput';
import NumberedBadge from 'components/ui/NumberedBadge';
import COLOR from 'constants/color';
import { t } from 'services/i18n.service';
import { useAppDispatch, useAppSelectorShallow } from 'store/hooks';
import { moreOptionModalActivitySelector } from 'store/reducer/modal/more-options.modal.selectors';
import { updateMoreOptionCheckLists } from 'store/reducer/modal/slice';
import { increment } from 'utils/helpers';

const Checklist = () => {
  const dispatch = useAppDispatch();
  const activity = useAppSelectorShallow(moreOptionModalActivitySelector);
  const checklistItems = activity?.check_list ?? [];

  const handleAddItem = () => {
    dispatch(updateMoreOptionCheckLists([...checklistItems, '']));
  };

  const handleDeleteItem = (index: number) => {
    dispatch(
      updateMoreOptionCheckLists(
        checklistItems.filter((_, itemIndex) => itemIndex !== index)
      )
    );
  };

  const handleItemChange = (index: number, value: string) => {
    dispatch(
      updateMoreOptionCheckLists(
        checklistItems.map((item, itemIndex) =>
          itemIndex === index ? value : item
        )
      )
    );
  };

  return (
    <div className='w-full flex flex-col ~gap-4/6'>
      <div className='flex items-center justify-between ~gap-4/6'>
        <p className='~text-xs/sm text-gray-400 dark:text-gray-200'>
          {t('tabs_revamp.checklist.make_checklist_description')}
        </p>

        <BaseButton
          title={t('tabs_revamp.checklist.add_item')}
          onClick={handleAddItem}
          size='xs'
          icon={
            <Add
              className='~w-3/4 ~h-3/4'
              fill={COLOR.PRIMARY.LIGHT_50}
              fillDarkMode={COLOR.PRIMARY.DARK_600}
            />
          }
        />
      </div>
      <div className='flex flex-col ~gap-3/6'>
        {!checklistItems.length ? (
          <p className='w-full text-center ~py-4/6 ~text-sm/base text-gray-500 dark:text-gray-400'>
            {t('no_check_list_found')}
          </p>
        ) : (
          checklistItems.map((item, index) => (
            <div
              key={`checklist-item-${index}`}
              className='flex items-center ~gap-2/4 w-full'>
              <NumberedBadge
                number={increment(index)}
                size='small'
                className='flex-shrink-0'
              />

              <div className='flex-1'>
                <FloatingLabelInput
                  type='text'
                  placeholder={t('tabs_revamp.checklist.enter_checklist_item')}
                  value={item}
                  onChange={(e) => handleItemChange(index, e.target.value)}
                  size='small'
                  variant='default'
                  showLabel={true}
                  label=''
                  error={!item.trim() ? t('validation.empty_content') : ''}
                />
              </div>

              <button
                onClick={() => handleDeleteItem(index)}
                className='flex-shrink-0 ~p-1.5/2 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-md transition-colors'
                aria-label={t('tabs_revamp.checklist.delete_item')}>
                <TrashOutlined className='~w-3/6 ~h-3/6' fill={COLOR.SEMANTIC.ERROR} />
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default Checklist;
